import { Form, Spinner } from "react-bootstrap";
import { useState } from "react";

const CabCitySelection = ({
  code,
  name,
  setCity,
  closeCitySelection,
  orname,
}) => {
  const [searchInput, setSearchInput] = useState("");
  const [cities, setCities] = useState([]);
  const [loading, setLoading] = useState(false);

const fetchDatas = (value) => {
  setLoading(true);

  const payload = { city: value };

  fetch("https://admin.travelsdata.com/api/Cab/City", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  })
    .then((response) => response.json())
    .then((json) => {
      const results = json.data
        .filter((loc) =>
          loc.name.toLowerCase().includes(value.toLowerCase()) ||
          loc.address.toLowerCase().includes(value.toLowerCase())
        );

      setCities(results);
      setLoading(false);
    })
    .catch((err) => {
      console.error("API fetch failed:", err);
      setLoading(false);
    });
};


  const handleInputChange = (event) => {
    const value = event.target.value;
    setSearchInput(value);

    if (value.length > 3) {
      fetchDatas(value);
    } else {
      setCities([]);
    }
  };

const handleCitySelection = (city) => {
  const selectedCity = {
    name: city.name,
    address: city.address,   
    full: city,      
  };

  setCity(selectedCity);
  closeCitySelection();
};



  return (
    <div className="bx_f2" id="divDepartauto">
      <div className="main_frm_f2" style={{ top: 0 }}>
        <div className="cntnt_f3_d">
          <div className="in_34">
            <div className="autosugst_newblock" style={{ left: "0" }}>
              <div className="fli-c-blv2">
                <div className="fli-m-bl">
                  <div className="fullblock_topcol">
                    <div
                      className="arrBackWhite"
                      id="backTosrch"
                      onClick={closeCitySelection}
                    ></div>
                    <div className="group input_autosugst autosHead">
                      Select {orname} City
                    </div>
                  </div>

                  <div>
                    <Form>
                      <a>
                        <input
                          type="text"
                          id="FromSector1Auto"
                          className="input_autosugst_New ac_input"
                          autoComplete="off"
                          onChange={handleInputChange}
                          placeholder="Enter your city name"
                        />
                      </a>
                    </Form>
                  </div>
                </div>
              </div>
            </div>

            <div className="auto_saugg" id="auto_saugg">
              <div className="mn-atu-pg">
                <ul id="mobFromhtml">

                  {loading && (
                    <div
                      style={{
                        padding: "10px 5px",
                        fontSize: "12px",
                        textAlign: "center",
                        width: "100%",
                      }}
                    >
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />{" "}
                      Please wait, fetching city list...
                    </div>
                  )}

                  {!loading &&
                    cities.map((city) => (
                      <li
                        key={city.name} // Use city.name as key since CityId doesn't exist
                        onClick={() => handleCitySelection(city)} // pass the entire city object
                      >
                        <div className="dest-nm" style={{ width: "100%" }}>
                          <span className="city-itemBusMobile">
                            <img
                              className="icLocAlt icLocAltBusMobile"
                              src="/Images/location.png"
                              alt="icon"
                              style={{
                                width: "30px",
                                height: "30px",
                                marginRight: "5px",
                              }}
                            />
                            {city.name}, {city.address}
                          </span>
                        </div>
                      </li>
                    ))}


                </ul>
              </div>
            </div>

          </div>
        </div>
        <div className="clr"></div>
      </div>
      <div className="blc_brd3"></div>
      <div className="clr"></div>
    </div>
  );
};

export default CabCitySelection;
